import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
export function PricingSection() {
  return <section id="oferta" className="py-12 bg-main relative overflow-hidden" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-161">
        <div className="text-center mb-8" data-id="element-162">
          <h2 className="text-3xl md:text-4xl font-serif text-title mb-3" data-id="element-163">
            Todo lo que necesitas para empezar (sin exposición).
          </h2>
          <p className="text-body text-lg max-w-xl mx-auto" data-id="element-164">
            Método + 2 recursos de implementación en un pack digital para
            ejecutar desde el primer día.
          </p>
        </div>

        <div className="max-w-lg mx-auto bg-card p-1 shadow-xl border border-[#D9D0C1]" data-id="element-165">
          <div className="bg-card p-8 md:p-12" data-id="element-166">
            <div className="text-center mb-8" data-id="element-167">
              <div className="flex items-center justify-center mb-2" data-id="element-168">
                <span className="text-body line-through text-xl mr-3" data-id="element-169">97€</span>
                <span className="text-5xl font-serif text-title" data-id="element-170">12€</span>
              </div>
              <p className="text-sm text-accent font-semibold mb-1" data-id="element-171">
                Precio de lanzamiento (24h)
              </p>
              <p className="text-body text-sm font-medium" data-id="element-172">
                Pago único · Acceso inmediato · Digital
              </p>
            </div>

            <div className="space-y-4 mb-10" data-id="element-173">
              {['Método Faceless Spain (guía principal)', 'Checklist de Lanzamiento Faceless (BONO)', 'Guiones DM Faceless — Copia y Pega (BONO)', 'Acceso inmediato (email + descarga directa)', 'Garantía 14 días'].map((item, index) => <div key={index} className="flex items-start" data-id="element-174">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-alt flex items-center justify-center mt-0.5 mr-3 border border-[#D9D0C1]" data-id="element-175">
                    <Check size={12} className="text-accent" data-id="element-176" />
                  </div>
                  <span className="text-title text-sm" data-id="element-177">{item}</span>
                </div>)}
            </div>

            <Button className="w-full justify-center text-lg py-4" withArrow data-id="element-178">
              Acceder al pack ahora
            </Button>

            <p className="text-center text-xs text-body mt-4" data-id="element-179">
              Incluye Checklist + Guiones DM · Descarga inmediata · Hoy 12€
            </p>
          </div>
        </div>
      </div>
    </section>;
}